import { motion } from "motion/react";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { ScreenDepth } from "@ryde/theme";

export const AnimationPageWrapperStyled = styled(
  motion.div,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "animation-page-wrapper",
})`
  position: absolute;
  top: 0;
  bottom: 0;
  inset-inline-start: 0;
  width: 100%;
  z-index: ${ScreenDepth.LAYOUT_RIGHT_ROUTE_ANIMATION_CONTAINER};
`;
